import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  useColorModeValue,
  Center,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

function AdminNav({page}) {
  return (
    <Card
      maxWidth="1200px"
      align
      mx="5"
      mt="10"
      mb="5"
      p="3"
      bg={useColorModeValue("gray.100", "gray.900")}
    >
      <Center mx="25" align="left" px="15">
        <Text fontSize="xl" as="b" mb="2">
          Hubit Administrator View
        </Text>
      </Center>
      <Center>
        <Box>
          <Link to="/admin/campaigns">
            <Text color="teal" as="u">
              Campaigns
            </Text>
          </Link>{" "}
          -&nbsp;
          <Link to="/admin/users">
            <Text color="teal" as="u">
              Users
            </Text>
          </Link>{" "}
            -&nbsp;
            <Link to="/admin/ratings">
              <Text color="teal" as="u">
                Ratings
              </Text>
            </Link>
        </Box>
      </Center>
    </Card>
  );
}

export default AdminNav;
